import ValidatedInput
  from '../../../../../../../common/components/ValidatedInput';
import GuestList from '../GuestList';
import credentialsFields from './credentials';
import addressFields from './homeAddress';
import personalDetailFields from './personalDetails';
import { scenarioHandlers } from './utils';

export default {
  ...personalDetailFields,
  ...addressFields,
  emailAddress: {
    component: ValidatedInput,
    disabled: true,
    label: 'Email',
    type: 'email',
    validation: [
      {
        checkValid: value => value.length <= 80,
        restrictInput: true,
        events: ['onChange'],
      },
    ],
    maxLength: 80,
    counter: true,
  },
  ...credentialsFields,
  guestNames: {
    hide: data => !scenarioHandlers.showGuests(data),
    component: GuestList,
  },
};



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/FieldConfig/index.js